import styled, { css } from 'styled-components/macro'
import { TableCell, TableContainer } from '@material-ui/core'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
`
export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.medium};
    margin-bottom: 16px;
  `}
`

export const SecaoOpcional = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
  margin-left: 6px;
`

export const TableContainerCustomizado = styled(TableContainer)`
  ${media.greaterThan('medium')`
    width: 60% !important;
    margin-left: auto;
    margin-right: auto;
  `}
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.lightGray};
    border-radius: 8px;
    border-collapse: collapse;
  `}
`

export const TableCellCustomizado = styled(TableCell)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.lightGray};
  `}
`
